function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#send_svg__clip0_11928_582)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.217 14.564V4.448l.143-.124-.143-.153v-.546H-.25v11.367h16.467v-.428zm-7.919-3.062l6.975-6.215v8.06l-3.16-3.432-.17-.184-.184.17-.326.302-.183.17.169.183 3.217 3.492H1.544l3.217-3.492.169-.184-.183-.17-.326-.3-.184-.171-.17.184-3.373 3.663V5.094l7.273 6.409.166.146.165-.147zm-.167-1.113L1.529 4.57H14.66l-6.53 5.82z",
  fill: "#D44400",
  stroke: "#D44400",
  strokeWidth: 0.5
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "send_svg__clip0_11928_582"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .875)",
  d: "M0 0h16v16H0z"
})));

function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgSend;